import { Position } from './position.model';

export class EventPosition {

  public placeId: string;
  public position?: Position;

}
